const WIZARD_MATCH_LABELS: Record<string, string> = {
  fundraising: 'Fundraising',
  entrepreneurship: 'Entrepreneurship',
  go_to_market: 'Go-to-Market',
  sales: 'Sales',
  negotiation: 'Negotiation',
  business_operations: 'Business Operations',
  leadership: 'Leadership',
  communication: 'Communication',
  productivity: 'Productivity',
  health: 'Health',
  investing: 'Investing',
  education: 'Education',
};

const WIZARD_INDUSTRY_SLUGS: Record<string, string> = {
  fundraising: 'fundraising',
  entrepreneurship: 'entrepreneurship',
  go_to_market: 'go-to-market',
  sales: 'sales',
  negotiation: 'negotiation',
  business_operations: 'business-operations',
  leadership: 'leadership',
  communication: 'communication',
  productivity: 'productivity',
  health: 'health',
  investing: 'investing',
  education: 'education',
};

const WIZARD_MATCH_SLUGS: Record<string, string> = {
  fundraising: 'fundraising',
  entrepreneurship: 'entrepreneurship',
  'go-to-market': 'go_to_market',
  sales: 'sales',
  negotiation: 'negotiation',
  'business-operations': 'business_operations',
  leadership: 'leadership',
  communication: 'communication',
  productivity: 'productivity',
  health: 'health',
  investing: 'investing',
  education: 'education',
};

export const WIZARD_INDUSTRY_FALLBACK_URL = '/lenses?matched=go_to_market#go-to-market';

export type WizardMatchMessage = {
  title: string;
  description: string;
  loadingTitle: string;
  loadingDescription: string;
};

export function buildWizardIndustryRedirectPath(industryId: string): string | null {
  const slug = WIZARD_INDUSTRY_SLUGS[industryId];
  if (!slug) return null;
  return `/lenses?matched=${encodeURIComponent(industryId)}#${slug}`;
}

export function isWizardIndustryRedirectPath(value: unknown): value is string {
  if (typeof value !== 'string') return false;
  return Object.keys(WIZARD_INDUSTRY_SLUGS)
    .some((industryId) => buildWizardIndustryRedirectPath(industryId) === value);
}

export function resolveWizardIndustryRedirectPath(value: unknown): string {
  return isWizardIndustryRedirectPath(value) ? value : WIZARD_INDUSTRY_FALLBACK_URL;
}

export function resolveWizardMatchParam(search: string, hash: string): string | null {
  const matched = new URLSearchParams(search).get('matched');
  if (matched) return matched;

  const hashSlug = decodeURIComponent(hash.replace(/^#/, '')).replace(/^industry-/, '').trim();
  if (!hashSlug) return null;

  return WIZARD_MATCH_SLUGS[hashSlug] ?? null;
}

export function getWizardMatchMessage(wizardMatchParam: string | null): WizardMatchMessage | null {
  if (!wizardMatchParam) return null;

  const industryLabel = WIZARD_MATCH_LABELS[wizardMatchParam];
  if (!industryLabel) return null;

  return {
    title: `Matched to ${industryLabel}`,
    description: `Applyt matched your goal to ${industryLabel}. Review these expert methods and choose the Lens that fits best.`,
    loadingTitle: `Your goal fits ${industryLabel}`,
    loadingDescription: `Opening ${industryLabel} expert methods that can help you choose the right Lens for your goal.`,
  };
}
